import { ContextMode, getAllContextModes, getContextModeIcon, getContextModeLabel } from './modalityConfig';
import { useMemo } from 'react';

interface ModalityExpandedProps {
    isExpanded: boolean;
    currentContextMode: ContextMode;
    onContextModeChange: (contextMode: ContextMode) => void;
}

const ModalityExpanded = ({ isExpanded, currentContextMode, onContextModeChange }: ModalityExpandedProps) => {
    const contextModes = getAllContextModes();

    // Calculate the offset to center the selected icon above the base icon
    const offset = useMemo(() => {
        const selectedIndex = contextModes.indexOf(currentContextMode);
        const totalIcons = contextModes.length;
        const iconWidth = 32; // 28px (w-7) + 4px margins

        // Calculate how much to shift left to align the selected icon
        const offsetFromCenter = (selectedIndex - (totalIcons - 1) / 2) * iconWidth;
        return -offsetFromCenter;
    }, [currentContextMode, contextModes]);

    return (
        <div
            className={`absolute bottom-10 left-1/2 flex items-center transition-all duration-200 ease-out ${
                isExpanded ? 'opacity-100' : 'opacity-0 pointer-events-none'
            }`}
            style={{ transform: `translateX(calc(-50% + ${offset}px))` }}
        >
            <div className="flex items-center bg-gray-200 dark:bg-neutral-800 rounded-full p-1 cursor-pointer">
                {contextModes.map((contextMode) => {
                    const ContextModeIcon = getContextModeIcon(contextMode);
                    return (
                        <button
                            key={contextMode}
                            onClick={() => onContextModeChange(contextMode)}
                            className={`flex items-center justify-center w-7 h-7 rounded-full transition-all duration-150 mx-0.5 ${
                                currentContextMode === contextMode
                                    ? 'bg-blue-500 text-white'
                                    : 'text-neutral-700 dark:text-neutral-200 hover:bg-gray-300 dark:hover:bg-neutral-700'
                            }`}
                            data-tooltip-id="main-tooltip"
                            data-tooltip-content={getContextModeLabel(contextMode)}
                            data-tooltip-place="top"
                            data-tooltip-delay-show={250}
                        >
                            <ContextModeIcon size={16} />
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default ModalityExpanded;